import { getText } from './http';

class SeasonApi {
    constructor(b2cHost, urlPart) {
        this.b2cHost = b2cHost;
        this.urlPart = urlPart;
    }

    getUrlSuffix(projectId, seasonId) {
        return `v1/${projectId}/football/seasons/${seasonId}/${this.urlPart}`;
    }

    getUrl(projectId, seasonId) {
        return `${this.b2cHost}/${this.getUrlSuffix(projectId, seasonId)}`;
    }

    getJson(projectId, seasonId, setJson) {
        const url = `/api/sts-mls/b2c?b2cUrl=${encodeURIComponent(this.getUrlSuffix(projectId, seasonId))}`;
        return getText(url, setJson);
    }
}

export function getMatchApi(b2cHost) {
    return new SeasonApi(b2cHost, 'matches');
}

export function getTeamApi(b2cHost) {
    return new SeasonApi(b2cHost, 'teams');
}

export function getSeasonTeamStatisticsApi(b2cHost) {
    return new SeasonApi(b2cHost, 'stats/teams');
}

export function getSeasonPlayerStatisticsApi(b2cHost) {
    return new SeasonApi(b2cHost, 'stats/players');
}
